"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@emotion/react");
const styled_1 = __importDefault(require("@emotion/styled"));
const keyframesClick = (0, react_1.keyframes)(`from, {
    transform: scale(1)
  },
  25%, {
    transform: scale(0.99)
  }
  50%, {
    transform: scale(0.98)
  },
  75%, {
    transform: scale(0.99)
  }
  to, {
    transform: scale(1)
  }`);
const RootButton = styled_1.default.button({
    'cursor': 'pointer',
    'alignItems': 'center',
    'justifyContent': 'center',
    'display': 'inline-flex',
    'borderStyle': 'solid',
    'padding': '12px 57px',
    ':active': {
        animation: `${keyframesClick} 0.2s 1 linear`
    },
    ':disabled': {
        animation: 'none'
    }
});
exports.default = RootButton;
//# sourceMappingURL=RootButton.js.map